// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://t53ppis5y5a6ldygi6fg6mwsym.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-2:25b981fe-09b9-4ccc-aaba-2fd25862dd3b",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_7MLN5HBtv",
    "aws_user_pools_web_client_id": "3bpnht5fp6e7r46mjb423ngrmc"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js